/**
*功能名称：数据源管理
*创 建 人：whr
*日    期：2023/06/15 10:15:17
*/

import {DbCenterBaseApiV2} from "../DbCenterBaseApiV2";
import {Methods} from "@newview/infrastructure";
export class DbBackuptaskdataApi extends DbCenterBaseApiV2 {
    public get ControllerName(): any {
        return 'dbBackuptaskdata';
    }

    /**
     * 根据条件删除数据表
     * @param params
     */
    public async deleteByParams(params) {
        return await this.send(params, "deleteByParams", Methods.POST);
    }
  
}
